export default class PageConfig {
  public static isBrowser = typeof window !== `undefined` || typeof document !== 'undefined';
  public static isDevelopment = process.env.NODE_ENV === 'development';
}
